import React from 'react';
import { Paper, Typography, Box, Stack, Divider } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';

const CandidateReferences = ({ references }) => {
    if (!references || references.length === 0) {
        return null;
    }

    return (
        <Paper 
            elevation={0}
            sx={{ 
                p: 3, 
                mb: 3,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <PersonIcon sx={{ color: 'text.primary' }} />
                <Typography variant="h6" fontWeight={600} color="text.primary">
                    References
                </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />
            <Stack spacing={3}>
                {references.map((ref) => (
                    <Box
                        key={ref.id}
                        sx={{
                            p: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            '&:hover': {
                                backgroundColor: 'action.hover'
                            }
                        }}
                    >
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                            {ref.name}
                        </Typography>
                        {ref.position && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>
                                <WorkIcon fontSize="small" color="action" />
                                <Typography variant="body2" color="text.secondary">
                                    {ref.position}
                                </Typography>
                            </Box>
                        )}
                        <Stack spacing={1} sx={{ mt: 1.5 }}>
                            {ref.email && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <EmailIcon fontSize="small" color="action" />
                                    <Typography variant="body2" color="text.secondary">
                                        {ref.email}
                                    </Typography>
                                </Box>
                            )}
                            {ref.phone_number && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PhoneIcon fontSize="small" color="action" />
                                    <Typography variant="body2" color="text.secondary">
                                        {ref.phone_number}
                                    </Typography>
                                </Box>
                            )}
                            {ref.location && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <LocationOnIcon fontSize="small" color="action" />
                                    <Typography variant="body2" color="text.secondary">
                                        {ref.location}
                                    </Typography>
                                </Box>
                            )}
                        </Stack>
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
};

export default CandidateReferences;
